import axios from 'axios';

export const RRPService = {
  async getRRP(page, perPage) {
    const res = await axios.get('variables/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createRRP(data) {
    const res = await axios.post('variables/', data);

    if (res.status === 201) {
      return res.data;
    }
    return Promise.reject();
  },
  async editRRP(data, id) {
    const res = await axios.put(`variables/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deleteRRP(id) {
    const res = await axios.delete(`variables/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
